import { useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";
import { currentTheme, onThemeChange, setManualTheme } from "@/utils/dayNight";

export const ThemeToggle = ({ className = "" }) => {
  const [mode, setMode] = useState(currentTheme);
  useEffect(() => onThemeChange(setMode), []);
  const day = mode === "day";
  return (
    <button
      type="button"
      onClick={() => setMode(setManualTheme(day ? "night" : "day"))}
      aria-label={day ? "Passer en mode nuit" : "Passer en mode jour"}
      title={day ? "Mode nuit" : "Mode jour"}
      className={`w-9 h-9 shrink-0 rounded-full flex items-center justify-center transition-colors active:scale-90 ${day ? "bg-[#0B2545] text-[#FCD34D]" : "bg-[#FCD34D] text-[#0B2545]"} ${className}`}
      data-testid="theme-toggle-btn"
    >
      {day ? <Moon className="w-4 h-4" /> : <Sun className="w-4 h-4" />}
    </button>
  );
};
